import DOMPurify from "dompurify";
import {format} from "date-fns";
import React, { useEffect } from "react";

const generatePath = (route, params) => {
    return route.replace(/:([a-zA-Z]+)/g, (_, key) => params[key]);
};

const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
        return text.slice(0, maxLength) + '...';
    }
    return text;
};

const createMarkup = (html) => {
    return {__html: DOMPurify.sanitize(html)};
};

const DateFormat = (pros) => {
    const formattedDate = format(new Date(pros.date), 'dd/MM/yyyy');
    return <p>{formattedDate}</p>;
};

const FlashMessage = ({ message, duration, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, duration);
        return () => clearTimeout(timer);
    }, [duration, onClose]);

    const isError = /error|fail|wrong|invalid|incorrect|unauthorized/i.test(message);

    return (
        <div className={`fixed bottom-6 right-6 z-50 flex items-start gap-3 px-4 py-3 rounded-xl shadow-lg border max-w-sm animate-fade-in
            ${isError ? 'bg-red-50 border-red-200' : 'bg-white border-warm-200'}`}
        >
            <span className="flex-shrink-0 mt-0.5">
                {isError ? (
                    <svg className="w-4 h-4 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10" />
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01" />
                    </svg>
                ) : (
                    <svg className="w-4 h-4 text-warm-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                    </svg>
                )}
            </span>
            <p className={`text-sm font-medium flex-1 ${isError ? 'text-red-700' : 'text-warm-800'}`}>
                {message}
            </p>
            <button
                onClick={onClose}
                className={`flex-shrink-0 transition-colors ${isError ? 'text-red-300 hover:text-red-500' : 'text-warm-300 hover:text-warm-600'}`}
                aria-label="Dismiss"
            >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
    );
};

const formatString = (str) => {
    return str.replace(/ /g, "+");
}

export {truncateText, createMarkup, generatePath, DateFormat, FlashMessage, formatString};